"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a;

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.Consumer = (_a = react_1["default"].createContext({}), _a.Consumer), exports.Provider = _a.Provider;